import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { useDispatch } from 'react-redux';
import Form from 'erpcore/components/Form';
import Button from 'erpcore/components/Button';
import Svg from 'erpcore/components/Svg';
import Tooltip from 'erpcore/components/Tooltip';
import Modal from 'erpcore/components/Modal';
import { actions as challengesActions } from 'erpcore/screens/Challenges/Challenges.reducer';

const ChallengesDelete = ({ id, handleSubmit, submitting, callback }) => {
    const dispatch = useDispatch();
    const [opened, setOpened] = useState(false);
    const challengeIri = `api/challenges/${id}`;

    const handleModal = () => {
        setOpened(!opened);
    };

    const onSubmit = () => {
        return new Promise((resolve, reject) =>
            dispatch({
                promise: { resolve, reject },
                type: challengesActions.START_DELETE_CHALLENGE,
                iri: challengeIri
            })
        )
            .then(() => {
                callback();
            })
            .catch(error => {
                return error;
            })
            .finally(() => {
                handleModal();
            });
    };

    return (
        <Fragment>
            <Tooltip content="Delete challenge">
                <button type="button" onClick={() => handleModal()}>
                    <Svg icon="remove" />
                </button>
            </Tooltip>
            <Modal
                variation="small"
                opened={opened}
                onClose={() => handleModal()}
                title="Delete challenge"
                subtitle={<>Are you sure you want to delete this challenge?</>}
            >
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Button submit loading={submitting} label="Delete" />
                    <Button variation="secondary" label="Cancel" onClick={() => handleModal()} />
                </Form>
            </Modal>
        </Fragment>
    );
};

ChallengesDelete.defaultProps = {
    submitting: false,
    id: null,
    callback: () => {}
};

ChallengesDelete.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    callback: PropTypes.func
};

export default reduxForm({
    form: 'ChallengesDeleteForm',
    enableReinitialize: true
})(ChallengesDelete);
